import React from "react";
import { Toast } from "./toast";
import { useToast } from "@/hooks/use-toast";

export const Toaster: React.FC = () => {
	const { toasts, exitingToasts, dismiss } = useToast();
	const allToasts = [
		...toasts.map(t => ({ ...t, isExiting: false })),
		...exitingToasts.map(t => ({ ...t, isExiting: true })),
	];

	if (allToasts.length === 0) return null;

	return (
		<div className="fixed top-4 left-1/2 -translate-x-1/2 z-[100] flex flex-col gap-2 max-w-sm w-[calc(100%-2rem)] pointer-events-none">
			<div className="pointer-events-auto flex flex-col gap-2">
				{allToasts.map(toast => (
					<Toast
						key={toast.id}
						id={toast.id}
						title={toast.title}
						description={toast.description}
						variant={toast.variant}
						isExiting={toast.isExiting}
						onDismiss={dismiss}
					/>
				))}
			</div>
		</div>
	);
};
